import axios from 'axios'
import { ENTRYPOINT } from '../../../config/entrypoint'
import decode from 'jwt-decode'
import FileSaver from 'file-saver'

export default {
  state: {
    articles: Array,
    societeId: Number,
    articlesBiblio: Array,
    infoProjectAndClient: Object,
    typeApi: String
  },
  actions: {
    setTypeApi ({ commit }, payload) {
      commit('API_TYPE', payload)
    },
    setSocieteIdFromToken ({ commit }) {
      const decoded = decode(localStorage.getItem('token'))
      commit('SOCIETE_ID', decoded.societeId)
    },
    async setInfoProjetAndClient ({ commit }, data) {
      const projetData = await axios({ url: ENTRYPOINT + '/api/projets/' + data, method: 'GET' })
      const projectInfos = projetData.data.data

      const clientData = await axios({ url: ENTRYPOINT + '/api/clients/' + projectInfos.client.id, method: 'GET' })
      const clientInfos = clientData.data.data

      commit('INFO_PROJECT_AND_CLIENT', { project: projectInfos, client: clientInfos })
    },
    async addArticle ({ commit, state }, payload) {
      try {
        const resp = state.typeApi === 'spec' ? await axios({ url: ENTRYPOINT + '/api/specification-technique/ajout', data: payload, method: 'POST' }) : await axios({ url: ENTRYPOINT + '/api/article/ajout', data: payload, method: 'POST' })
        commit('SET_ARTICLES', resp.data.data.data)
        return resp.data.data
      } catch (err) {
        console.log('addArticle', err)
      }
    },
    async getArticle ({ commit, state }, projetId) {
      try {
        const resp = state.typeApi === 'spec' ? await axios({ url: ENTRYPOINT + '/api/specification-technique/' + projetId, method: 'GET' }) : await axios({ url: ENTRYPOINT + '/api/article/detail/' + projetId, method: 'GET' })
        commit('SET_ARTICLES', resp.data.data)
      } catch (err) {
        console.log('getArticle', err)
      }
    },

    async getInviteArticle ({ commit, state }, payload) {
      try {
        console.log(payload)
        const resp = state.typeApi === 'spec' ? await axios({ url: ENTRYPOINT + '/invite/specification-technique/' + payload.projectId + '?idInvitation=' + payload.idInvitation, method: 'GET' }) : await axios({ url: ENTRYPOINT + '/invite/article/detail/' + projetId, method: 'GET' })
        commit('SET_ARTICLES', resp.data.data)
      } catch (err) {
        console.log('getArticle', err)
      }
    },
    async updateArticle ({ commit, state }, payload) {
      try {
        const resp = state.typeApi === 'spec' ? await axios({ url: ENTRYPOINT + '/api/specification-technique/modification/' + payload.id, data: payload, method: 'POST' }) : await axios({ url: ENTRYPOINT + '/api/article/modification/' + payload.id, data: payload, method: 'POST' })
        commit('UPDATE_LIST_ARTICLE', resp.data.data.data)
      } catch (err) {
        console.log('updateArticle', err)
      }
    },
    async deleteArticle ({ commit, state }, payload) {
      try {
        const resp = state.typeApi === 'spec' ? await axios({ url: ENTRYPOINT + '/api/specification-technique/supprime/' + payload, method: 'DELETE' }) : await axios({ url: ENTRYPOINT + '/api/article/supprime/' + payload, method: 'DELETE' })
        commit('SET_ARTICLES', resp.data.data[0].data)
      } catch (err) {
        console.log('deleteArticle', err)
      }
    },
    async addArticleBiblio ({ commit, state }, payload) {
      try {
        const resp = state.typeApi === 'spec' ? await axios({ url: ENTRYPOINT + '/api/bibliotheque-specification-technique/ajout', data: payload, method: 'POST' }) : await axios({ url: ENTRYPOINT + '/api/bibliotheque-article/ajout', data: payload, method: 'POST' })
        commit('LIST_ARTICLES_BIBLIO', resp.data.data.data)
      } catch (err) {
        console.log('addArticleBiblio', err)
      }
    },
    async addToArticle ({ commit, state }, payload) {
      try {
        const resp = state.typeApi === 'spec' ? await axios({ url: ENTRYPOINT + '/api/specification-technique/ajout-bibilotheque/' + payload.idProjet + '/' + payload.idArticleBiblio, method: 'POST' }) : await axios({ url: ENTRYPOINT + '/api/article/ajout-bibilotheque/' + payload.idProjet + '/' + payload.idArticleBiblio, method: 'POST' })
        commit('UPDATE_LIST_ARTICLE', resp.data.data)
      } catch (err) {
        console.log('addArticleBiblio', err)
      }
    },
    async getArticleBiblio ({ commit, state }, payload) {
      try {
        const resp = state.typeApi === 'spec' ? await axios({ url: ENTRYPOINT + '/api/bibliotheque-specification-technique/detail/' + payload, method: 'GET' }) : await axios({ url: ENTRYPOINT + '/api/bibliotheque-article/detail/' + payload, method: 'GET' })
        commit('LIST_ARTICLES_BIBLIO', resp.data.data)
      } catch (err) {
        console.log('addArticleBiblio', err)
      }
    },

    async deleteArticleBiblio ({ commit, state }, payload) {
      try {
        const resp = state.typeApi === 'spec' ? await axios({ url: ENTRYPOINT + '/api/bibliotheque-specification-technique/supprime/' + payload, method: 'DELETE' }) : await axios({ url: ENTRYPOINT + '/api/bibliotheque-article/supprime/' + payload, method: 'DELETE' })
        commit('LIST_ARTICLES_BIBLIO', resp.data.data.data)
      } catch (err) {
        console.log('deleteArticleBiblio', err)
      }
    },
    async editArticleBiblio ({ commit, state }, payload) {
      try {
        const resp = state.typeApi === 'spec' ? await axios({ url: ENTRYPOINT + '/api/bibliotheque-specification-technique/modification/' + payload.id, data: payload.data, method: 'POST' }) : await axios({ url: ENTRYPOINT + '/api/bibliotheque-article/modification/' + payload.id, data: payload.data, method: 'POST' })
        commit('LIST_ARTICLES_BIBLIO', resp.data.data.data)
      } catch (err) {
        console.log('editArticleBiblio', err)
      }
    },
    async changeHierarchie ({ commit, state }, payload) {
      try {
        const resp = state.typeApi === 'spec' ? await axios({ url: ENTRYPOINT + `/api/bibliotheque-specification-technique/deplace/${payload.id}/${payload.direction}`, method: 'GET' }) : await axios({ url: ENTRYPOINT + `/api/bibliotheque-article/deplace/${payload.id}/${payload.direction}`, method: 'GET' })
        commit('LIST_ARTICLES_BIBLIO', resp.data.data.data)
      } catch (err) {
        console.log('changeHierarchie', err)
      }
    },
    async rechercheArticleBiblio ({ commit, state }, payload) {
      try {
        const resp = state.typeApi === 'spec' ? await axios({ url: ENTRYPOINT + '/api/bibliotheque-specification-technique/recherche/' + payload.type.value + '?recherche=' + payload.recherche, method: 'GET' }) : await axios({ url: ENTRYPOINT + '/api/bibliotheque-article/recherche/' + payload.type.value + '?recherche=' + payload.recherche, method: 'GET' })
        commit('LIST_ARTICLES_BIBLIO', resp.data.data)
      } catch (err) {
        console.log('rechercheArticleBiblio', err)
      }
    },
    async moveArticle ({ commit, state }, payload) {
      try {
        const resp = state.typeApi === 'spec' ? await axios({ url: ENTRYPOINT + '/api/specification-technique/deplace', data: payload, method: 'POST' }) : await axios({ url: ENTRYPOINT + '/api/article/deplace', data: payload, method: 'POST' })
        commit('UPDATE_LIST_ARTICLE', resp.data.data)
      } catch (err) {
        console.log('Move article', err)
      }
    },
    async exportArticle ({commit, state}, projetId) {
      try {
        const actionUrl = state.typeApi === 'spec' ? '/api/specification-technique/export/' : '/api/article/export/'
        const file = await axios({ url: ENTRYPOINT + actionUrl + projetId, method: 'GET', responseType: 'blob' })
        const fileName = file.headers['content-disposition'].split(';')[1].split('=')[1].replace(/"/gi, '')
        FileSaver.saveAs(file.data, fileName || 'articles-export.docx')
        return true
      } catch (err) {
        return false
      }
    }
  },
  getters: {
    articles: (state) => state.articles,
    societeId: (state) => state.societeId,
    articlesBiblio: (state) => state.articlesBiblio,
    infoProjectAndClient: (state) => state.infoProjectAndClient,
    typeApi: (state) => state.typeApi
  },
  mutations: {
    SET_ARTICLES (state, value) {
      state.articles = value
    },
    LIST_ARTICLES_BIBLIO (state, value) {
      state.articlesBiblio = value
    },
    ADD_ARTICLE_TO_LIST (state, value) {
      state.articles.push(value)
    },
    UPDATE_LIST_ARTICLE (state, value) {
      state.articles = value
    },
    SOCIETE_ID (state, value) {
      state.societeId = value
    },
    INFO_PROJECT_AND_CLIENT (state, value) {
      state.infoProjectAndClient = value
    },
    API_TYPE (state, value) {
      state.typeApi = value
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/articleCahier/index.js